export default __webpack_public_path__ + "static/media/pic3.c4299f9f.jpg";